export const ADMIN_ROOT_PATH = '/admin';
const getAdminRoutes = ({ rootPath }: { rootPath: string }) => ({
  HOME: {
    PATH: rootPath,
    getPath: () => rootPath,
  },
  COMPANIES: {
    PATH: `${rootPath}/companies`,
    getPath: () => `${rootPath}/companies`,
  },
  COMPANY: {
    PATH: `${rootPath}/companies/:id`,
    getPath: ({ companyId }: { companyId: string }) =>
      `${rootPath}/companies/${companyId}`,
  },
  LEARNERS: {
    PATH: `${rootPath}/companies/:id/learners`,
    getPath: ({ companyId }: { companyId: string }) =>
      `${rootPath}/companies/${companyId}/learners`,
  },
  COHORTS: {
    PATH: `${rootPath}/companies/:id/cohorts`,
    getPath: ({ companyId }: { companyId: string }) =>
      `${rootPath}/companies/${companyId}/cohorts`,
  },
  MENTORS: {
    PATH: `${rootPath}/companies/:id/mentors`,
    getPath: ({ companyId }: { companyId: string }) =>
      `${rootPath}/companies/${companyId}/mentors`,
  },
  ASSESSMENT_TESTERS: {
    PATH: `${rootPath}/companies/:id/tests`,
    getPath: ({ companyId }: { companyId: string }) =>
      `${rootPath}/companies/${companyId}/tests`,
  },
  ASSESSMENT_TEST_RESULTS: {
    PATH: `${rootPath}/companies/:id/test-results`,
    getPath: ({ companyId }: { companyId: string }) =>
      `${rootPath}/companies/${companyId}/test-results`,
  },
  ASSESSMENT_TEST_RESULT: {
    PATH: `${rootPath}/companies/:id/test-results/:assessmentTestSessionId`,
    getPath: ({
      companyId,
      assessmentTestSessionId,
    }: {
      companyId: string;
      assessmentTestSessionId: string;
    }) =>
      `${rootPath}/companies/${companyId}/test-results/${assessmentTestSessionId}`,
  },
  PROGRESS: {
    PATH: `${rootPath}/companies/:id/progress`,
    getPath: ({ companyId }: { companyId: string }) =>
      `${rootPath}/companies/${companyId}/progress`,
  },
  SETTINGS: {
    PATH: `${rootPath}/companies/:id/settings`,
    getPath: ({ companyId }: { companyId: string }) =>
      `${rootPath}/companies/${companyId}/settings`,
  },
  SOS_QUESTIONS: {
    PATH: `${rootPath}/companies/:id/sos-questions`,
    getPath: ({ companyId }: { companyId: string }) =>
      `${rootPath}/companies/${companyId}/sos-questions`,
  },
  REPLY_TO_SOS_QUESTION: {
    PATH: `${rootPath}/companies/:id/sos-questions/:submissionId/exercise/:questionId`,
    getPath: ({
      companyId,
      submissionId,
      questionId,
    }: {
      companyId: string;
      submissionId: string;
      questionId: string;
    }) =>
      `${rootPath}/companies/${companyId}/sos-questions/${submissionId}/exercise/${questionId}`,
  },
  OFFICE_HOURS: {
    PATH: `${rootPath}/companies/:id/office-hours`,
    getPath: ({ companyId }: { companyId: string }) =>
      `${rootPath}/companies/${companyId}/office-hours`,
  },
  OFFICE_HOURS_SUBCOHORT: {
    PATH: `${rootPath}/companies/:id/office-hours/:officeHourId`,
    getPath: ({
      companyId,
      officeHourId,
    }: {
      companyId: string;
      officeHourId: string;
    }) => `${rootPath}/companies/${companyId}/office-hours/${officeHourId}`,
  },
  COMPANY_PROJECTS: {
    PATH: `${rootPath}/companies/:id/company-projects`,
    getPath: ({ companyId }: { companyId: string }) =>
      `${rootPath}/companies/${companyId}/company-projects`,
  },
  COMPANY_PROJECT_SUBMISSION: {
    PATH: `${rootPath}/companies/:id/company-projects/:submissionId`,
    getPath: ({
      companyId,
      submissionId,
    }: {
      companyId: string;
      submissionId: string;
    }) => `${rootPath}/companies/${companyId}/company-projects/${submissionId}`,
  },
  CMS_MODULES: {
    PATH: `${rootPath}/cms/modules`,
    getPath: () => `${rootPath}/cms/modules`,
  },
  CMS_MODULE_CREATE: {
    PATH: `${rootPath}/cms/modules/new`,
    getPath: () => `${rootPath}/cms/modules/new`,
  },
  CMS_MODULE_EDIT: {
    PATH: `${rootPath}/cms/modules/:slug/edit`,
    getPath: ({ slug }: { slug: string }) =>
      `${rootPath}/cms/modules/${slug}/edit`,
  },
  CMS_MODULE_PREVIEW: {
    PATH: `${rootPath}/cms/preview/modules/:slug`,
    getPath: ({ slug }: { slug: string }) =>
      `${rootPath}/cms/preview/modules/${slug}`,
  },
  CMS_MODULE_PREVIEW_ACTIVITY: {
    PATH: `${rootPath}/cms/preview/modules/:slug/activities/:activitySlug`,
    getPath: ({ slug, activitySlug }: { slug: string; activitySlug: string }) =>
      `${rootPath}/cms/preview/modules/${slug}/activities/${activitySlug}`,
  },
  CMS_PROJECTS: {
    PATH: `${rootPath}/cms/projects`,
    getPath: () => `${rootPath}/cms/projects`,
  },
  CMS_PROJECT_CREATE: {
    PATH: `${rootPath}/cms/projects/new`,
    getPath: () => `${rootPath}/cms/projects/new`,
  },
  CMS_PROJECT_EDIT: {
    PATH: `${rootPath}/cms/projects/:slug/edit`,
    getPath: ({ slug }: { slug: string }) =>
      `${rootPath}/cms/projects/${slug}/edit`,
  },
  CMS_PROJECT_PREVIEW: {
    PATH: `${rootPath}/cms/preview/projects/:slug`,
    getPath: ({ slug }: { slug: string }) =>
      `${rootPath}/cms/preview/projects/${slug}`,
  },
  CMS_ASSESSMENT_TESTS: {
    PATH: `${rootPath}/cms/assessment-tests`,
    getPath: () => `${rootPath}/cms/assessment-tests`,
  },
  CMS_ASSESSMENT_TEST_CREATE: {
    PATH: `${rootPath}/cms/assessment-tests/new`,
    getPath: () => `${rootPath}/cms/assessment-tests/new`,
  },
  CMS_ASSESSMENT_TEST_EDIT: {
    PATH: `${rootPath}/cms/assessment-tests/:slug/edit`,
    getPath: ({ slug }: { slug: string }) =>
      `${rootPath}/cms/assessment-tests/${slug}/edit`,
  },
  CMS_ASSESSMENT_TEST_PREVIEW: {
    PATH: `${rootPath}/cms/preview/assessment-tests/:slug`,
    getPath: ({ slug }: { slug: string }) =>
      `${rootPath}/cms/preview/assessment-tests/${slug}`,
  },
});

export const PREVIEW_ROOT_PATH = '/preview';
const getPreviewRoutes = ({ rootPath }: { rootPath: string }) => ({
  MODULE_DASHBOARD: {
    PATH: `${rootPath}/:contentSlug/dashboard`,
    getPath: ({ moduleSlug }: { moduleSlug: string }) =>
      `${rootPath}/${moduleSlug}/dashboard`,
  },
  ACTIVITY: {
    PATH: `${rootPath}/missions/:missionSlug/activities/:activitySlug`,
    getPath: ({
      missionSlug,
      activitySlug,
    }: {
      missionSlug?: string;
      activitySlug: string;
    }) => {
      if (!missionSlug) {
        throw new Error('Mission slug missing');
      }
      return `${rootPath}/missions/${missionSlug}/activities/${activitySlug}`;
    },
  },
  PROJECT: {
    PATH: `${rootPath}/projects/:projectSlug`,
    getPath: ({ projectSlug }: { projectSlug: string }) =>
      `${rootPath}/projects/${projectSlug}`,
  },
  PROJECTS_DASHBOARD: {
    PATH: `${rootPath}/projects`,
    getPath: () => `${rootPath}/projects`,
  },
});

const getAuthRoutes = () => ({
  LOGIN: {
    PATH: '/auth',
    getPath: () => '/auth',
  },
  CALLBACK: {
    PATH: '/auth-callback',
    getPath: () => '/auth-callback',
  },
  CONFIRM_EMAIL: {
    PATH: '/auth/confirm-email',
    getPath: () => '/auth/confirm-email',
  },
});

export const TEAMS_ROOT_PATH = '/';
const getTeamsRoutes = ({ rootPath }: { rootPath: string }) => ({
  // team-specific HOME and LOGIN routes are only used by the DF App
  HOME: {
    PATH: `${rootPath}`,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getPath: ({ teamSlug }: { teamSlug?: string }) => {
      throw new Error('does not exist');
    },
  },
  LOGIN: {
    PATH: `${rootPath}/auth`,
    getPath: ({ teamSlug }: { teamSlug?: string }) => {
      return `/${teamSlug}/auth`;
    },
  },
  TEST_INVITE: {
    PATH: `/:companySlug/test`,
    getPath: ({ teamSlug }: { teamSlug?: string }) => {
      return `/${teamSlug}/test`;
    },
    getURL: ({ teamSlug }: { teamSlug?: string }) => {
      return `${window.location.origin}/${teamSlug}/test`;
    },
  },
  LEARN_INVITE: {
    PATH: `${rootPath}/learn`,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getPath: ({ teamSlug }: { teamSlug?: string }) => {
      throw new Error('does not exist');
    },
  },
  // content routes
  // note that MODULE_DASHBOARD and ACTIVITY aren't namespaced by the root path in the non-df app, but instead by the teamSlug (track slug)
  MODULE_DASHBOARD: {
    PATH: `/:trackSlug/dashboard`,
    getPath: ({
      trackSlug,
    }: {
      teamSlug?: string;
      moduleSlug: string;
      trackSlug?: string;
    }) => {
      if (!trackSlug) {
        throw new Error('Track slug missing');
      }
      return `/${trackSlug}/dashboard`;
    },
  },
  ACTIVITY: {
    PATH: `/:trackSlug/missions/:missionSlug/activities/:activitySlug`,
    getPath: ({
      trackSlug,
      activitySlug,
      missionSlug,
    }: {
      teamSlug?: string;
      trackSlug?: string;
      activitySlug: string;
      missionSlug?: string;
    }) => {
      if (!missionSlug || !trackSlug) {
        throw new Error('missionSlug and trackSlug are required');
      }
      return `/${trackSlug}/missions/${missionSlug}/activities/${activitySlug}`;
    },
  },
  PROJECT: {
    PATH: `/teams/projects/:projectSlug`,
    getPath: ({ projectSlug }: { teamSlug?: string; projectSlug: string }) => {
      return `/teams/projects/${projectSlug}`;
    },
  },
  PROJECTS_DASHBOARD: {
    PATH: `/teams/projects`,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getPath: ({ teamSlug }: { teamSlug?: string }) => {
      return `/teams/projects`;
    },
  },
  // learner routes
  PROFILE_ONBOARDING: {
    PATH: `/teams/profile/onboard`,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getPath: ({ teamSlug }: { teamSlug?: string }) => {
      return `/teams/profile/onboard`;
    },
  },
  COHORT_ONBOARDING: {
    PATH: `/teams/cohort/onboard`,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getPath: ({ teamSlug }: { teamSlug?: string }) => {
      return `/teams/cohort/onboard`;
    },
  },
  COMPANY_PROJECT_EXAMPLES: {
    PATH: `/project-examples`,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getPath: ({ teamSlug }: { teamSlug?: string }) => {
      return `/project-examples`;
    },
  },
  COMPANY_PROJECT_CHECKIN_1: {
    PATH: `/teams/company-project/checkin1`,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getPath: ({ teamSlug }: { teamSlug?: string }) => {
      return `/teams/company-project/checkin1`;
    },
  },
  COMPANY_PROJECT_CHECKIN_2: {
    PATH: `/teams/company-project/checkin2`,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getPath: ({ teamSlug }: { teamSlug?: string }) => {
      return `/teams/company-project/checkin2`;
    },
  },
  COMPANY_PROJECT_SUBMIT: {
    PATH: `/teams/company-project/submit`,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getPath: ({ teamSlug }: { teamSlug?: string }) => {
      return `/teams/company-project/submit`;
    },
  },
  COHORT_FEEDBACK: {
    PATH: `/teams/cohort-feedback`,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getPath: ({ teamSlug }: { teamSlug?: string }) => {
      return `/teams/cohort-feedback`;
    },
  },
  ASSESSMENT_TEST: {
    PATH: `/:companySlug/tests/:testSlug`,
    getPath: ({
      teamSlug,
      testSlug,
    }: {
      teamSlug: string;
      testSlug: string;
    }) => {
      return `/${teamSlug}/tests/${testSlug}`;
    },
  },
});

export const PROSUMER_PUBLIC_UPSELL_ROOT_PATH = '/buy';
export const PROSUMER_ONBOARDING_ROOT_PATH = '/join';
const getProsumerRoutes = () => ({
  // content routes
  MODULE_DASHBOARD: {
    PATH: '/prosumer/:contentSlug/dashboard',
    getPath: ({ moduleSlug }: { moduleSlug: string }) =>
      `/prosumer/${moduleSlug}/dashboard`,
  },
  ACTIVITY: {
    PATH: '/prosumer/missions/:missionSlug/activities/:activitySlug',
    getPath: ({
      missionSlug,
      activitySlug,
    }: {
      missionSlug: string;
      activitySlug: string;
    }) => `/prosumer/missions/${missionSlug}/activities/${activitySlug}`,
  },
  PROJECT: {
    PATH: `/projects/:projectSlug`,
    getPath: ({ projectSlug }: { projectSlug: string }) =>
      `/projects/${projectSlug}`,
  },
  PROJECTS_DASHBOARD: {
    PATH: `/projects`,
    getPath: () => `/projects`,
  },
  // logged in purchase routes
  PAYMENT: {
    PATH: `/payment`,
    getPath: () => `/payment`,
  },
  BENEFITS_UPSELL: {
    PATH: `/benefits`,
    getPath: () => `/benefits`,
  },
  PLAN_UPSELL: {
    PATH: `/learning-plan`,
    getPath: () => `/learning-plan`,
  },
  PAYMENT_CALLBACK: {
    PATH: `/payment-callback`,
    getPath: () => `/payment-callback`,
  },
  APP_USER_UPSELL: {
    PATH: `/app-user-signup`,
    getPath: () => `/app-user-signup`,
  },
  // public purchase routes
  PUBLIC_PAYMENT: {
    PATH: `${PROSUMER_PUBLIC_UPSELL_ROOT_PATH}/payment`,
    getPath: () => `${PROSUMER_PUBLIC_UPSELL_ROOT_PATH}/payment`,
  },
  PUBLIC_BENEFITS_UPSELL: {
    PATH: `${PROSUMER_PUBLIC_UPSELL_ROOT_PATH}/benefits`,
    getPath: () => `${PROSUMER_PUBLIC_UPSELL_ROOT_PATH}/benefits`,
  },
  PUBLIC_PLAN_UPSELL: {
    PATH: `${PROSUMER_PUBLIC_UPSELL_ROOT_PATH}/plan`,
    getPath: () => `${PROSUMER_PUBLIC_UPSELL_ROOT_PATH}/plan`,
  },
  PUBLIC_PAYMENT_CALLBACK: {
    PATH: `${PROSUMER_PUBLIC_UPSELL_ROOT_PATH}/payment-callback`,
    getPath: () => `${PROSUMER_PUBLIC_UPSELL_ROOT_PATH}/payment-callback`,
  },
  UNSUBSCRIBE: {
    PATH: `/unsubscribe`,
    getPath: () => `/unsubscribe`,
  },
  ONBOARDING: {
    PATH: `${PROSUMER_ONBOARDING_ROOT_PATH}/:step?`,
    getPath: (stepName?: string) =>
      `${PROSUMER_ONBOARDING_ROOT_PATH}${stepName ? `/${stepName}` : ''}`,
  },
});

export const PUBLIC_ROOT_PATH = '/public';
const getPublicRoutes = ({ rootPath }: { rootPath: string }) => ({
  SQL_PLAYROUND: {
    PATH: `${rootPath}/playground`,
    getPath: () => `${rootPath}/playground`,
  },
  PYTHON_PLAYROUND_EMBED: {
    PATH: `${rootPath}/python-playground`,
    getPath: () => `${rootPath}/python-playground`,
  },
  SQL_PLAYROUND_EMBED: {
    PATH: `${rootPath}/sql-playground`,
    getPath: () => `${rootPath}/sql-playground`,
  },
});

export const ROUTES = {
  PUBLIC: getPublicRoutes({ rootPath: PUBLIC_ROOT_PATH }),
  ADMIN: getAdminRoutes({ rootPath: ADMIN_ROOT_PATH }),
  PREVIEW: getPreviewRoutes({ rootPath: PREVIEW_ROOT_PATH }),
  AUTH: getAuthRoutes(),
  TEAMS: getTeamsRoutes({ rootPath: TEAMS_ROOT_PATH }),
  PROSUMER: getProsumerRoutes(),
  HOME: {
    PATH: `/`,
    getPath: () => `/`,
  },
};

const WEBSITE_TITLE = 'Enki';

export const getActivityPageTitle = (activityTitle: string) =>
  `${WEBSITE_TITLE} | ${activityTitle}`;
export const getProjectPageTitle = (projectTitle: string) =>
  `${WEBSITE_TITLE} | ${projectTitle}`;
export const getDashboardPageTitle = (contentTitle: string) =>
  `${WEBSITE_TITLE} | ${contentTitle}`;
export const getProjectExamplesPageTitle = () =>
  `${WEBSITE_TITLE} | Project Examples`;
export const getHomePageTitle = () => `${WEBSITE_TITLE} | Learning Platform`;
export const getSubmitProjectPageTitle = () =>
  `${WEBSITE_TITLE} | Submit Project`;
export const getCohortFeedbackPageTitle = () =>
  `${WEBSITE_TITLE} | Cohort Feedback`;
export const getNotFoundPageTitle = () => `${WEBSITE_TITLE} | 404 Not Found`;
export const getProjectsPageTitle = () => `${WEBSITE_TITLE} | Projects`;
